var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.9999 3C14.7613 3 16.9999 5.23858 16.9999 8C16.9999 10.7614 14.7613 13 11.9999 13C9.23849 13 6.99991 10.7614 6.99991 8C6.99991 5.23858 9.23849 3 11.9999 3ZM11.9999 4C9.79077 4 7.99991 5.79086 7.99991 8C7.99991 10.2091 9.79077 12 11.9999 12C14.209 12 15.9999 10.2091 15.9999 8C15.9999 5.79086 14.209 4 11.9999 4ZM11.9999 15C15.5264 15 18.4438 17.6077 18.929 21H17.917C17.4409 18.1623 14.9729 16 11.9999 16C9.02692 16 6.55895 18.1623 6.08287 21H5.0708C5.55603 17.6077 8.47344 15 11.9999 15Z"}));
}

Profile.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Profile;

Profile.default = Profile;
